import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from './GaugeScoreCard.module.scss';

// Gauge shape/angles mirror DashboardOverviewNew's OverallProductivity gauge
// (not imported from it — that component lives in a different view and is
// out of scope to refactor here), rebuilt with `colors.scss` tokens instead
// of hardcoded hex so it stays consistent with the rest of this redesign.
export const GaugeScoreCardComponent = ({ score, label, subtext }) => {
  const gaugeData = [{ value: score }, { value: 100 - score }];

  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>
        <span>PRODUCTIVITY SCORE</span>
        <InfoTooltip
          title="Productivity Score"
          description="Share of tracked time spent actively working today."
          calculation={{ formula: '(Active time / Total tracked time) × 100' }}
        />
      </div>

      <div className={styles.gaugeWrapper}>
        <ResponsiveContainer width="100%" height={110}>
          <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient
                id="appUsageGaugeGradient"
                x1="0"
                y1="0"
                x2="1"
                y2="0"
              >
                <stop offset="0%" stopColor="var(--indigo-600)" />
                <stop offset="100%" stopColor="var(--indigo-400)" />
              </linearGradient>
            </defs>
            {/* Track arc */}
            <Pie
              data={[{ value: 100 }]}
              cx="50%"
              cy="80%"
              startAngle={210}
              endAngle={-30}
              innerRadius={64}
              outerRadius={74}
              dataKey="value"
              strokeWidth={0}
            >
              <Cell fill="var(--indigo-100)" />
            </Pie>
            {/* Score arc */}
            <Pie
              data={gaugeData}
              cx="50%"
              cy="80%"
              startAngle={210}
              endAngle={-30}
              innerRadius={64}
              outerRadius={74}
              dataKey="value"
              strokeWidth={0}
            >
              <Cell fill="url(#appUsageGaugeGradient)" />
              <Cell fill="transparent" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className={styles.gaugeCenter}>
          <div className={styles.gaugeScore}>{score}%</div>
          <div className={styles.gaugeBadge}>{label}</div>
        </div>
      </div>

      <p className={styles.subtext}>{subtext}</p>
    </div>
  );
};

GaugeScoreCardComponent.displayName = 'GaugeScoreCard';
